<!--
 * @Author: hongye
 * @Date: 2020-10-28 16:54:24
 * @LastEditTime: 2021-08-17 18:15:23
 * @Description: 
-->
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
          class="main-r_top_nav active"
      >在线文档</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom"> 
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">地址：使用接入方提供的URL</p> 
          <p class="api_addr_info">请求方法：<span>POST</span></p>
          <p class="api_addr_info">数据类型：<span>X-WWW-FORM-URLENCODED </span></p>
          <p class="api_addr_info">响应类型：<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
  import onlineDoc from "../components/onlineDoc";
  export default {
    name: "statusFeedback",

    components: {onlineDoc},
    data() {
      return {
        onlineData: {
          //接口描述
          apiDesc: "接入方在提供了物流状态回传相关信息并完成了下订单操作后，当订单相关的状态变化时，系统会根据接入方配置的推送账户主动推送物流信息。",

          //参数描述  START
          postDataList: [
            //   请求头参数
            {
              title: 'Headers',
              value: [
                {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: "接入方在平台的api账户标识",},
                {name: "digest", type: "String", require: "Y", normal: "", describe: "签名字符串",},
                {name: "timestamp", type: "Number", require: "Y", normal: "", describe: "时间戳，毫秒",},
              ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title: "业务参数",
              value: [
                {name: "txlogisticId", type: "String(32)", require: "Y", normal: "", describe: "客户订单编号"},
                {name: "billCode", type: "String(32)", require: "N", normal: "", describe: "极兔运单编号"},
                {name: "networkName", type: "String(32)", require: "N", normal: "", describe: "网点名称（“已调派业务员”回传）"},
                {name: "pickStaffName", type: "String(32)", require: "N", normal: "", describe: "业务员名称（“已调派业务员”回传）"},
                {name: "pickStaffPhone", type: "String(32)", require: "N", normal: "", describe: "业务员联系方式（“已调派业务员”回传）"},
                {name: "jtOrderId", type: "String(32)", require: "Y", normal: "", describe: "极兔订单编号"},
                {name: "weight", type: "String(32)", require: "N", normal: "", describe: "重量（“已揽收”“已取件”时回传）"},
                {name: "reason", type: "String(32)", require: "N", normal: "", describe: "订单取消原因（“已取消”时回传）"},
                {name: "scanType", type: "String(32)", require: "Y", normal: "", describe: "状态(“已调派业务员”,“已揽收”，“已取件”，“已取消”)"},
                {name: "time", type: "String(32)", require: "Y", normal: "", describe: "时间"},
                {name: "carrierCode", type: "String(32)", require: "Y", normal: "JTSD", describe: "承运商编码"},
              ]
            },
          ],
          //参数描述  END
          //报文描述 start
          responseDataList: [

            //   响应参数
            {
              title: '响应参数',
              value: [
                {name: "code", type: "String", require: "Y", normal: "", describe: "返回码，见附录"},
                {name: "msg", type: "String", require: "Y", normal: "", describe: "描述"},
                {name: "data", type: "String", require: "Y", normal: "", describe: "业务数据"},
              ]
            },
          ],
          //请求示例
          requestCode: `Header：
apiAccount=1362
digest=U40e5sumorgd3YgZzU61Mw==
timestamp=1565238848921

Body：
bizContent={
"billCode":"JT4000073746531",
"jtOrderId":"136072928692285467",
"networkName":"南京雨花台板桥网点",
"pickStaffName":"test0040",
"pickStaffPhone":"15110110110",
"scanType":"已调派业务员",
"time":"2020-06-03 18:44:34"
}

{
"billCode":"JT4000073746531",
"jtOrderId":"136072928692285467",
"scanType":"已入仓",
"time":"2020-06-03 18:48:51",
"weight":"2"
}

{
"billCode":"JT4000071327280",
"jtOrderId":"136074416353194043",
"reason":"客户取消订单",
"scanType":"已取消",
"time":"2020-06-03 18:52:01"
}`,
          //返回示例
          responseCode: {
            'code': '1',
            'msg': 'success',
            'data':"SUCCESS"
        } ,
        errcodeJson: []
        }
      }
    },
    methods: {
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../css/apiTest.scss";
</style>
